import React from "react";
import { Box, Skeleton } from "@mui/material";

export default function DescriptionSkeleton() {
  return (
    <Box sx={{ 
      padding: 5, 
      flexDirection: 'column', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      backgroundColor: 'grey.50'
    }}>
      <Skeleton
        variant="rectangular"
        width="60%"
        height={40}
        sx={{ 
          mb: 4,
          bgcolor: 'grey.300',
          borderRadius: 1
        }}
      />
      <Skeleton
        variant="rectangular"
        width={205}
        height={250}
        sx={{ 
          mb: 4,
          bgcolor: 'grey.300',
          borderRadius: '5%'
        }}
      />
      
      <Skeleton
        variant="rectangular"
        width="90%"
        height={200}
        sx={{ 
          mb: 3,
          bgcolor: 'grey.300',
          borderRadius: 2
        }}
      />
      
      <Skeleton
        variant="rectangular"
        width={120}
        height={40}
        sx={{ 
          bgcolor: 'grey.300',
          borderRadius: 2
        }}
      />
    </Box>
  );
}